export const skillsEn = {
  skillCategories: {
    programming: 'Programming',
    web_development: 'Web Development',
    backend: 'Backend Development',
    database: 'Database',
    devops: 'DevOps & Cloud',
    mobile: 'Mobile Development',
    design: 'Design & Creative',
    office: 'Office & Administration',
    project_management: 'Project Management',
    data_science: 'Data Science & Analytics',
    marketing: 'Marketing & Advertising',
    sales: 'Sales & Business Development',
    soft_skills: 'Soft Skills',
    finance: 'Finance & Accounting',
    healthcare: 'Healthcare',
    logistics: 'Logistics & Supply Chain',
    manufacturing: 'Manufacturing & Production',
    electrical: 'Electrical & Electronics',
    automotive: 'Automotive',
    construction: 'Construction & Building',
    agriculture: 'Agriculture & Farming',
    hospitality: 'Hospitality & Tourism',
    legal: 'Legal & Law',
    education: 'Education & Teaching',
    environment: 'Environment & Sustainability',
    quality_management: 'Quality Management',
    hr: 'Human Resources',
    safety: 'Safety & Compliance',
    other: 'Other',
  },
  skills: {
    // Existing skills (updated with better naming)
    ms_word: 'Microsoft Word',
    ms_excel: 'Microsoft Excel',
    ms_powerpoint: 'Microsoft PowerPoint',
    autodesk: 'AutoDesk',
    corel_draw: 'Corel Draw',
    canva: 'Canva',
    adobe: 'Adobe',
    sap: 'SAP',
    salesforce: 'Salesforce',
    trello: 'Trello',
    angular: 'Angular',
    blockchain: 'Blockchain',
    c: 'C',
    cpp: 'C++',
    csharp: 'C#',
    java: 'Java',
    python: 'Python',
    ios: 'iOS',
    dotnet: '.NET',
    php: 'PHP',
    plc: 'PLC Programming',

    // Programming Languages
    javascript: 'JavaScript',
    typescript: 'TypeScript',
    golang: 'Go (Golang)',
    rust: 'Rust',
    ruby: 'Ruby',
    kotlin: 'Kotlin',
    swift: 'Swift',
    scala: 'Scala',
    r_language: 'R',
    perl: 'Perl',
    dart: 'Dart',
    elixir: 'Elixir',
    haskell: 'Haskell',
    assembly: 'Assembly',
    matlab: 'MATLAB',

    // Web Development
    react: 'React',
    vuejs: 'Vue.js',
    nextjs: 'Next.js',
    nuxtjs: 'Nuxt.js',
    svelte: 'Svelte',
    html5: 'HTML5',
    css3: 'CSS3',
    sass: 'Sass/SCSS',
    tailwind: 'Tailwind CSS',
    bootstrap: 'Bootstrap',
    material_ui: 'Material UI',
    jquery: 'jQuery',
    webpack: 'Webpack',
    vite: 'Vite',
    redux: 'Redux',
    graphql: 'GraphQL',
    rest_api: 'REST API',
    websockets: 'WebSockets',

    // Backend
    nodejs: 'Node.js',
    expressjs: 'Express.js',
    django: 'Django',
    flask: 'Flask',
    fastapi: 'FastAPI',
    spring_boot: 'Spring Boot',
    laravel: 'Laravel',
    ruby_on_rails: 'Ruby on Rails',
    aspnet_core: 'ASP.NET Core',
    gin_go: 'Gin (Go)',
    nestjs: 'NestJS',
    symfony: 'Symfony',
    codeigniter: 'CodeIgniter',

    // Database
    postgresql: 'PostgreSQL',
    mysql: 'MySQL',
    mongodb: 'MongoDB',
    redis: 'Redis',
    elasticsearch: 'Elasticsearch',
    sqlite: 'SQLite',
    mariadb: 'MariaDB',
    mssql: 'Microsoft SQL Server',
    oracle_db: 'Oracle Database',
    dynamodb: 'DynamoDB',
    cassandra: 'Cassandra',
    couchdb: 'CouchDB',
    firebase: 'Firebase',
    supabase: 'Supabase',
    neo4j: 'Neo4j',

    // DevOps
    docker: 'Docker',
    kubernetes: 'Kubernetes',
    aws: 'AWS (Amazon Web Services)',
    azure: 'Microsoft Azure',
    gcp: 'Google Cloud Platform',
    terraform: 'Terraform',
    ansible: 'Ansible',
    jenkins: 'Jenkins',
    gitlab_cicd: 'GitLab CI/CD',
    github_actions: 'GitHub Actions',
    circleci: 'CircleCI',
    git: 'Git',
    linux: 'Linux',
    nginx: 'Nginx',
    apache: 'Apache',
    prometheus: 'Prometheus',
    grafana: 'Grafana',
    elk_stack: 'ELK Stack',

    // Mobile
    react_native: 'React Native',
    flutter: 'Flutter',
    android: 'Android Development',
    ios_dev: 'iOS Development',
    swiftui: 'SwiftUI',
    jetpack_compose: 'Jetpack Compose',
    xamarin: 'Xamarin',
    ionic: 'Ionic',
    cordova: 'Cordova',

    // Design
    figma: 'Figma',
    photoshop: 'Adobe Photoshop',
    illustrator: 'Adobe Illustrator',
    adobe_xd: 'Adobe XD',
    indesign: 'Adobe InDesign',
    premiere_pro: 'Adobe Premiere Pro',
    after_effects: 'Adobe After Effects',
    sketch: 'Sketch',
    invision: 'InVision',
    ui_ux_design: 'UI/UX Design',
    graphic_design: 'Graphic Design',
    video_editing: 'Video Editing',
    '3d_modeling': '3D Modeling',
    blender: 'Blender',
    cinema_4d: 'Cinema 4D',
    procreate: 'Procreate',

    // Office
    ms_office: 'Microsoft Office Suite',
    google_workspace: 'Google Workspace',
    excel_advanced: 'Excel Advanced',
    data_entry: 'Data Entry',
    data_analysis: 'Data Analysis',
    typing_speed: 'Typing Speed',
    admin_support: 'Administrative Support',
    document_management: 'Document Management',

    // Project Management
    agile: 'Agile',
    scrum: 'Scrum',
    kanban: 'Kanban',
    jira: 'Jira',
    asana: 'Asana',
    monday: 'Monday.com',
    ms_project: 'Microsoft Project',
    confluence: 'Confluence',
    notion: 'Notion',
    basecamp: 'Basecamp',

    // Data Science
    machine_learning: 'Machine Learning',
    deep_learning: 'Deep Learning',
    tensorflow: 'TensorFlow',
    pytorch: 'PyTorch',
    pandas: 'Pandas',
    numpy: 'NumPy',
    scikit_learn: 'Scikit-learn',
    nlp: 'Natural Language Processing (NLP)',
    computer_vision: 'Computer Vision',
    data_visualization: 'Data Visualization',
    tableau: 'Tableau',
    power_bi: 'Power BI',
    jupyter: 'Jupyter Notebooks',
    statistics: 'Statistics',
    ab_testing: 'A/B Testing',

    // Marketing
    seo: 'SEO (Search Engine Optimization)',
    sem: 'SEM (Search Engine Marketing)',
    google_ads: 'Google Ads',
    facebook_ads: 'Facebook Ads',
    social_media_marketing: 'Social Media Marketing',
    content_marketing: 'Content Marketing',
    email_marketing: 'Email Marketing',
    copywriting: 'Copywriting',
    google_analytics: 'Google Analytics',
    marketing_automation: 'Marketing Automation',
    hubspot: 'HubSpot',
    mailchimp: 'Mailchimp',
    brand_management: 'Brand Management',
    influencer_marketing: 'Influencer Marketing',

    // Sales
    crm_systems: 'CRM Systems',
    cold_calling: 'Cold Calling',
    lead_generation: 'Lead Generation',
    negotiation: 'Negotiation',
    sales_pipeline: 'Sales Pipeline Management',
    b2b_sales: 'B2B Sales',
    b2c_sales: 'B2C Sales',
    account_management: 'Account Management',
    customer_relationship: 'Customer Relationship Management',
    sales_presentations: 'Sales Presentations',

    // Soft Skills
    leadership: 'Leadership',
    team_management: 'Team Management',
    communication: 'Communication',
    public_speaking: 'Public Speaking',
    presentation_skills: 'Presentation Skills',
    problem_solving: 'Problem Solving',
    critical_thinking: 'Critical Thinking',
    time_management: 'Time Management',
    organization: 'Organization',
    teamwork: 'Teamwork',
    collaboration: 'Collaboration',
    adaptability: 'Adaptability',
    creativity: 'Creativity',
    conflict_resolution: 'Conflict Resolution',
    decision_making: 'Decision Making',
    emotional_intelligence: 'Emotional Intelligence',
    work_ethic: 'Work Ethic',
    attention_to_detail: 'Attention to Detail',

    // Finance
    accounting: 'Accounting',
    financial_analysis: 'Financial Analysis',
    bookkeeping: 'Bookkeeping',
    quickbooks: 'QuickBooks',
    xero: 'Xero',
    tax_preparation: 'Tax Preparation',
    budgeting: 'Budgeting',
    financial_reporting: 'Financial Reporting',
    auditing: 'Auditing',
    payroll: 'Payroll Processing',

    // Healthcare
    medical_terminology: 'Medical Terminology',
    patient_care: 'Patient Care',
    emr: 'Electronic Medical Records (EMR)',
    cpr: 'CPR Certified',
    first_aid: 'First Aid',
    vital_signs: 'Vital Signs Monitoring',
    medication_admin: 'Medication Administration',
    medical_coding: 'Medical Coding',
    healthcare_compliance: 'Healthcare Compliance',
    hipaa: 'HIPAA Knowledge',

    // Logistics
    supply_chain: 'Supply Chain Management',
    warehouse_management: 'Warehouse Management',
    inventory_control: 'Inventory Control',
    forklift: 'Forklift Operation',
    shipping_receiving: 'Shipping & Receiving',
    logistics_coordination: 'Logistics Coordination',
    quality_control: 'Quality Control',
    route_planning: 'Route Planning',
    procurement: 'Procurement',
    wms_software: 'WMS Software',

    // New skills from migration 56 (sorted alphabetically)
    '3d_visualization': '3D Visualization',
    abap: 'ABAP',
    academic_supervision: 'Academic Supervision',
    access_control: 'Access Control',
    access_control_systems: 'Access Control Systems',
    accounting_software: 'Accounting Software',
    acoustics: 'Acoustics',
    active_listening: 'Active Listening',
    activity_planning: 'Activity Planning',
    actuarial_software: 'Actuarial Software',
    adaptive_teaching: 'Adaptive Teaching',
    adas_recalibration: 'ADAS Recalibration',
    adhesive_application: 'Adhesive Application',
    administrative_law: 'Administrative Law',
    advanced_nursing: 'Advanced Nursing',
    adverse_event_reporting: 'Adverse Event Reporting',
    advertising_sales: 'Advertising Sales',
    advisory_services: 'Advisory Services',
    agricultural_law: 'Agricultural Law',
    agricultural_machinery: 'Agricultural Machinery',
    agricultural_software: 'Agricultural Software',
    aircraft_systems: 'Aircraft Systems',
    alarm_systems: 'Alarm Systems',
    alignment_equipment: 'Alignment Equipment',
    alterations: 'Alterations',
    analytical_chemistry: 'Analytical Chemistry',
    analytics: 'Analytics',
    anatomy_knowledge: 'Anatomy Knowledge',
    android_studio: 'Android Studio',
    anesthesia: 'Anesthesia',
    animal_handling: 'Animal Handling',
    animal_husbandry: 'Animal Husbandry',
    animal_nutrition: 'Animal Nutrition',
    animal_surgery: 'Animal Surgery',
    animation: 'Animation',
    api_documentation: 'API Documentation',
    applicant_tracking_systems: 'Applicant Tracking Systems',
    arc_welding: 'Arc Welding',
    architectural_design: 'Architectural Design',
    archival_procedures: 'Archival Procedures',
    art_history: 'Art History',
    aspen_plus: 'Aspen Plus',
    assembly_procedures: 'Assembly Procedures',
    assessment: 'Assessment',
    audience_analysis: 'Audience Analysis',
    audio_editing: 'Audio Editing',
    audio_engineering: 'Audio Engineering',
    audit_procedures: 'Audit Procedures',
    autocad: 'AutoCAD',
    autocad_mep: 'AutoCAD MEP',
    automotive_diagnostics: 'Automotive Diagnostics',
    automotive_electronics: 'Automotive Electronics',
    automotive_painting: 'Automotive Painting',
    automotive_software: 'Automotive Software',
    award_presentations: 'Award Presentations',
    bakery_equipment: 'Bakery Equipment',
    bankruptcy_law: 'Bankruptcy Law',
    bar_operations: 'Bar Operations',
    batch_processing: 'Batch Processing',
    battery_management: 'Battery Management',
    behavioral_assessment: 'Behavioral Assessment',
    benefit_administration: 'Benefit Administration',
    beverage_service: 'Beverage Service',
    bidding: 'Bidding',
    billing: 'Billing',
    bim: 'BIM',
    biochemistry: 'Biochemistry',
    blueprint_reading: 'Blueprint Reading',
    boat_maintenance: 'Boat Maintenance',
    body_repair: 'Body Repair',
    bookbinding: 'Bookbinding',
    brake_systems: 'Brake Systems',
    brand_development: 'Brand Development',
    brewing: 'Brewing',
    broadcast_engineering: 'Broadcast Engineering',
    building_codes: 'Building Codes',
    building_maintenance: 'Building Maintenance',
    building_regulations: 'Building Regulations',
    business_analysis: 'Business Analysis',
    business_law: 'Business Law',
    cad_cam_dental: 'CAD/CAM Dental',
    cad_software: 'CAD Software',
    calibration: 'Calibration',
    cam_software: 'CAM Software',
    camera_operation: 'Camera Operation',
    campaign_management: 'Campaign Management',
    candidate_evaluation: 'Candidate Evaluation',
    candidate_screening: 'Candidate Screening',
    candidate_sourcing: 'Candidate Sourcing',
    cannabis_cultivation: 'Cannabis Cultivation',
    caregiver_support: 'Caregiver Support',
    carpentry: 'Carpentry',
    case_management: 'Case Management',
    cash_handling: 'Cash Handling',
    catia: 'CATIA',
    cctv_systems: 'CCTV Systems',
    ceramic_techniques: 'Ceramic Techniques',
    ceremony_planning: 'Ceremony Planning',
    change_management: 'Change Management',
    chemical_engineering: 'Chemical Engineering',
    chemical_handling: 'Chemical Handling',
    chemical_processes: 'Chemical Processes',
    chemistry: 'Chemistry',
    child_development: 'Child Development',
    child_nutrition: 'Child Nutrition',
    child_safety: 'Child Safety',
    civil_3d: 'Civil 3D',
    civil_engineering: 'Civil Engineering',
    civil_law: 'Civil Law',
    claim_processing: 'Claim Processing',
    class_management: 'Class Management',
    classroom_management: 'Classroom Management',
    cleaning_procedures: 'Cleaning Procedures',
    client_counseling: 'Client Counseling',
    client_interaction: 'Client Interaction',
    climate_control: 'Climate Control',
    clinical_documentation: 'Clinical Documentation',
    clinical_protocols: 'Clinical Protocols',
    clinical_research: 'Clinical Research',
    clinical_skills: 'Clinical Skills',
    cloud_services: 'Cloud Services',
    cnc_operation: 'CNC Operation',
    cnc_programming: 'CNC Programming',
    cnc_setup: 'CNC Setup',
    coaching: 'Coaching',
    coating_application: 'Coating Application',
    cocktail_preparation: 'Cocktail Preparation',
    coding_standards: 'Coding Standards',
    cognitive_assessment: 'Cognitive Assessment',
    color_matching: 'Color Matching',
    combustion_systems: 'Combustion Systems',
    commercial_law: 'Commercial Law',
    community_engagement: 'Community Engagement',
    community_outreach: 'Community Outreach',
    compensation_analysis: 'Compensation Analysis',
    competitive_analysis: 'Competitive Analysis',
    compiler_design: 'Compiler Design',
    compliance_auditing: 'Compliance Auditing',
    compliance_documentation: 'Compliance Documentation',
    compliance_management: 'Compliance Management',
    compliance_monitoring: 'Compliance Monitoring',
    compliance_reporting: 'Compliance Reporting',
    compliance_training: 'Compliance Training',
    component_testing: 'Component Testing',
    composting: 'Composting',
    computer_hardware: 'Computer Hardware',
    concrete_work: 'Concrete Work',
    conflict_management: 'Conflict Management',
    constitutional_law: 'Constitutional Law',
    construction_management: 'Construction Management',
    construction_safety: 'Construction Safety',
    content_creation: 'Content Creation',
    content_development: 'Content Development',
    content_moderation: 'Content Moderation',
    continuous_improvement: 'Continuous Improvement',
    contract_drafting: 'Contract Drafting',
    contract_law: 'Contract Law',
    contract_negotiation: 'Contract Negotiation',
    control_systems: 'Control Systems',
    corporate_law: 'Corporate Law',
    corrective_actions: 'Corrective Actions',
    cost_analysis: 'Cost Analysis',
    cost_control: 'Cost Control',
    cost_estimation: 'Cost Estimation',
    counseling: 'Counseling',
    course_development: 'Course Development',
    court_procedures: 'Court Procedures',
    crane_operation: 'Crane Operation',
    creative_direction: 'Creative Direction',
    credit_analysis: 'Credit Analysis',
    criminal_law: 'Criminal Law',
    crisis_intervention: 'Crisis Intervention',
    crisis_management: 'Crisis Management',
    critical_care: 'Critical Care',
    crop_management: 'Crop Management',
    crop_protection: 'Crop Protection',
    culinary_arts: 'Culinary Arts',
    cultural_sensitivity: 'Cultural Sensitivity',
    curriculum_design: 'Curriculum Design',
    curriculum_development: 'Curriculum Development',
    custom_fabrication: 'Custom Fabrication',
    customer_education: 'Customer Education',
    customer_engagement: 'Customer Engagement',
    customer_retention: 'Customer Retention',
    customer_service: 'Customer Service',
    customs_regulations: 'Customs Regulations',
    cutting_techniques: 'Cutting Techniques',
    data_collection: 'Data Collection',
    data_interpretation: 'Data Interpretation',
    data_management: 'Data Management',
    database_design: 'Database Design',
    database_management: 'Database Management',
    deal_negotiation: 'Deal Negotiation',
    decision_support: 'Decision Support',
    decorating: 'Decorating',
    demolition: 'Demolition',
    dental_equipment: 'Dental Equipment',
    dental_hygiene: 'Dental Hygiene',
    dental_procedures: 'Dental Procedures',
    design_software: 'Design Software',
    design_thinking: 'Design Thinking',
    desktop_support: 'Desktop Support',
    diagnostic_equipment: 'Diagnostic Equipment',
    diagnostic_imaging: 'Diagnostic Imaging',
    diagnostic_testing: 'Diagnostic Testing',
    diesel_engines: 'Diesel Engines',
    diet_planning: 'Diet Planning',
    differentiated_instruction: 'Differentiated Instruction',
    digital_fabrication: 'Digital Fabrication',
    digital_literacy: 'Digital Literacy',
    digital_marketing: 'Digital Marketing',
    disability_awareness: 'Disability Awareness',
    disability_support: 'Disability Support',
    disaster_response: 'Disaster Response',
    disinfection: 'Disinfection',
    dispensing: 'Dispensing',
    dispute_resolution: 'Dispute Resolution',
    distribution_management: 'Distribution Management',
    document_control: 'Document Control',
    document_review: 'Document Review',
    dosage_calculation: 'Dosage Calculation',
    drainage_systems: 'Drainage Systems',
    drawing_interpretation: 'Drawing Interpretation',
    drilling: 'Drilling',
    drone_operation: 'Drone Operation',
    drug_interactions: 'Drug Interactions',
    drywall: 'Drywall',
    due_diligence: 'Due Diligence',
    e_learning: 'E-Learning',
    ecg_interpretation: 'ECG Interpretation',
    educational_assessment: 'Educational Assessment',
    educational_software: 'Educational Software',
    educational_technology: 'Educational Technology',
    electrical_cad: 'Electrical CAD',
    electrical_codes: 'Electrical Codes',
    electrical_installation: 'Electrical Installation',
    electrical_maintenance: 'Electrical Maintenance',
    electrical_systems: 'Electrical Systems',
    electrical_testing: 'Electrical Testing',
    electrical_troubleshooting: 'Electrical Troubleshooting',
    electronic_assembly: 'Electronic Assembly',
    electronic_testing: 'Electronic Testing',
    electronics_repair: 'Electronics Repair',
    embedded_systems: 'Embedded Systems',
    emergency_care: 'Emergency Care',
    emergency_preparedness: 'Emergency Preparedness',
    emergency_procedures: 'Emergency Procedures',
    emergency_response: 'Emergency Response',
    emissions_testing: 'Emissions Testing',
    employee_engagement: 'Employee Engagement',
    employee_relations: 'Employee Relations',
    employment_law: 'Employment Law',
    encryption: 'Encryption',
    end_of_life_care: 'End Of Life Care',
    energy_efficiency: 'Energy Efficiency',
    energy_management: 'Energy Management',
    engine_diagnostics: 'Engine Diagnostics',
    engine_repair: 'Engine Repair',
    environmental_compliance: 'Environmental Compliance',
    environmental_impact: 'Environmental Impact',
    environmental_law: 'Environmental Law',
    environmental_monitoring: 'Environmental Monitoring',
    environmental_science: 'Environmental Science',
    equipment_calibration: 'Equipment Calibration',
    equipment_inspection: 'Equipment Inspection',
    equipment_maintenance: 'Equipment Maintenance',
    equipment_operation: 'Equipment Operation',
    equipment_repair: 'Equipment Repair',
    equipment_setup: 'Equipment Setup',
    ergonomics: 'Ergonomics',
    escalation_management: 'Escalation Management',
    estate_planning: 'Estate Planning',
    ethical_standards: 'Ethical Standards',
    event_coordination: 'Event Coordination',
    event_planning: 'Event Planning',
    evidence_collection: 'Evidence Collection',
    evidence_handling: 'Evidence Handling',
    excavation: 'Excavation',
    exhibit_design: 'Exhibit Design',
    experimental_design: 'Experimental Design',
    facility_management: 'Facility Management',
    family_law: 'Family Law',
    fashion_design: 'Fashion Design',
    fastening_systems: 'Fastening Systems',
    feasibility_studies: 'Feasibility Studies',
    feed_formulation: 'Feed Formulation',
    feedback_analysis: 'Feedback Analysis',
    feedback_collection: 'Feedback Collection',
    fermentation: 'Fermentation',
    fertilization: 'Fertilization',
    field_service: 'Field Service',
    filing_systems: 'Filing Systems',
    film_production: 'Film Production',
    filtration_systems: 'Filtration Systems',
    financial_management: 'Financial Management',
    financial_modeling: 'Financial Modeling',
    financial_planning: 'Financial Planning',
    fire_safety: 'Fire Safety',
    fire_systems: 'Fire Systems',
    firewall_management: 'Firewall Management',
    firmware_development: 'Firmware Development',
    fitting: 'Fitting',
    fixture_installation: 'Fixture Installation',
    fleet_management: 'Fleet Management',
    flooring: 'Flooring',
    food_handling: 'Food Handling',
    food_preparation: 'Food Preparation',
    food_safety: 'Food Safety',
    food_service: 'Food Service',
    forecasting: 'Forecasting',
    forensic_analysis: 'Forensic Analysis',
    formulation: 'Formulation',
    foundation_work: 'Foundation Work',
    framing: 'Framing',
    freight_handling: 'Freight Handling',
    front_desk: 'Front Desk',
    front_end_alignment: 'Front End Alignment',
    fuel_systems: 'Fuel Systems',
    fundraising: 'Fundraising',
    furniture_assembly: 'Furniture Assembly',
    furniture_design: 'Furniture Design',
    g_code: 'G-Code',
    garment_construction: 'Garment Construction',
    gdpr: 'GDPR',
    gem_identification: 'Gem Identification',
    geriatric_care: 'Geriatric Care',
    glass_installation: 'Glass Installation',
    glazing: 'Glazing',
    gmp: 'GMP',
    grant_writing: 'Grant Writing',
    graphic_software: 'Graphic Software',
    greenhouse_management: 'Greenhouse Management',
    grief_counseling: 'Grief Counseling',
    grinding: 'Grinding',
    grooming: 'Grooming',
    groundwater_monitoring: 'Groundwater Monitoring',
    group_facilitation: 'Group Facilitation',
    group_therapy: 'Group Therapy',
    guest_relations: 'Guest Relations',
    guest_services: 'Guest Services',
    hand_tools: 'Hand Tools',
    handling_techniques: 'Handling Techniques',
    hardware_installation: 'Hardware Installation',
    hardware_troubleshooting: 'Hardware Troubleshooting',
    harvest_management: 'Harvest Management',
    hazardous_materials: 'Hazardous Materials',
    hazmat: 'HAZMAT',
    health_education: 'Health Education',
    health_informatics: 'Health Informatics',
    health_promotion: 'Health Promotion',
    health_screening: 'Health Screening',
    hearing_tests: 'Hearing Tests',
    heat_treatment: 'Heat Treatment',
    heating_systems: 'Heating Systems',
    heavy_equipment: 'Heavy Equipment',
    help_desk: 'Help Desk',
    herd_management: 'Herd Management',
    historical_research: 'Historical Research',
    horticulture: 'Horticulture',
    hospitality_management: 'Hospitality Management',
    housekeeping: 'Housekeeping',
    hr_analytics: 'HR Analytics',
    hr_policies: 'HR Policies',
    hr_software: 'HR Software',
    hvac: 'HVAC',
    hvac_design: 'HVAC Design',
    hvac_installation: 'HVAC Installation',
    hvac_systems: 'HVAC Systems',
    hydraulic_systems: 'Hydraulic Systems',
    hygiene_protocols: 'Hygiene Protocols',
    ict_integration: 'ICT Integration',
    illustration: 'Illustration',
    image_processing: 'Image Processing',
    imaging_equipment: 'Imaging Equipment',
    immigration_law: 'Immigration Law',
    immunization: 'Immunization',
    impact_assessment: 'Impact Assessment',
    incident_investigation: 'Incident Investigation',
    incident_management: 'Incident Management',
    incident_reporting: 'Incident Reporting',
    inclusive_education: 'Inclusive Education',
    individual_education_plans: 'Individual Education Plans',
    industrial_automation: 'Industrial Automation',
    industrial_design: 'Industrial Design',
    industrial_equipment: 'Industrial Equipment',
    industrial_maintenance: 'Industrial Maintenance',
    infection_control: 'Infection Control',
    infusion_therapy: 'Infusion Therapy',
    injection_molding: 'Injection Molding',
    inspection_procedures: 'Inspection Procedures',
    installation_procedures: 'Installation Procedures',
    instructional_design: 'Instructional Design',
    instrument_calibration: 'Instrument Calibration',
    instrumentation: 'Instrumentation',
    insulation: 'Insulation',
    insurance_law: 'Insurance Law',
    integration_testing: 'Integration Testing',
    intellectual_property: 'Intellectual Property',
    interactive_learning: 'Interactive Learning',
    interior_design: 'Interior Design',
    interpreting: 'Interpreting',
    interview_techniques: 'Interview Techniques',
    interviewing: 'Interviewing',
    inventory_management: 'Inventory Management',
    investment_analysis: 'Investment Analysis',
    irrigation: 'Irrigation',
    irrigation_systems: 'Irrigation Systems',
    iso_9001: 'ISO 9001',
    jewelry_making: 'Jewelry Making',
    jewelry_repair: 'Jewelry Repair',
    job_analysis: 'Job Analysis',
    job_costing: 'Job Costing',
    laboratory_equipment: 'Laboratory Equipment',
    laboratory_procedures: 'Laboratory Procedures',
    laboratory_techniques: 'Laboratory Techniques',
    labor_law: 'Labor Law',
    labor_relations: 'Labor Relations',
    landscape_design: 'Landscape Design',
    landscape_maintenance: 'Landscape Maintenance',
    language_instruction: 'Language Instruction',
    lathe_operation: 'Lathe Operation',
    laundry_operations: 'Laundry Operations',
    layout_design: 'Layout Design',
    lean_principles: 'Lean Principles',
    learning_assessment: 'Learning Assessment',
    learning_disabilities: 'Learning Disabilities',
    legal_compliance: 'Legal Compliance',
    legal_documentation: 'Legal Documentation',
    legal_research: 'Legal Research',
    legal_writing: 'Legal Writing',
    lesson_planning: 'Lesson Planning',
    library_management: 'Library Management',
    library_systems: 'Library Systems',
    licensing: 'Licensing',
    lifting_equipment: 'Lifting Equipment',
    lighting_design: 'Lighting Design',
    lighting_systems: 'Lighting Systems',
    literature_review: 'Literature Review',
    litigation: 'Litigation',
    livestock_management: 'Livestock Management',
    load_calculation: 'Load Calculation',
    loan_processing: 'Loan Processing',
    lockout_tagout: 'Lockout Tagout',
    logistics_planning: 'Logistics Planning',
    loss_prevention: 'Loss Prevention',
    low_voltage_systems: 'Low Voltage Systems',
    lubrication: 'Lubrication',
    machine_learning_engineering: 'Machine Learning Engineering',
    machine_operation: 'Machine Operation',
    machine_setup: 'Machine Setup',
    machining_processes: 'Machining Processes',
    maintenance_planning: 'Maintenance Planning',
    maintenance_procedures: 'Maintenance Procedures',
    makeup_application: 'Makeup Application',
    manufacturing_processes: 'Manufacturing Processes',
    maritime_law: 'Maritime Law',
    market_analysis: 'Market Analysis',
    market_research: 'Market Research',
    masonry: 'Masonry',
    massage_therapy: 'Massage Therapy',
    materials_handling: 'Materials Handling',
    materials_science: 'Materials Science',
    materials_selection: 'Materials Selection',
    measurement_techniques: 'Measurement Techniques',
    mechanical_assembly: 'Mechanical Assembly',
    mechanical_design: 'Mechanical Design',
    mechanical_systems: 'Mechanical Systems',
    media_relations: 'Media Relations',
    medical_billing: 'Medical Billing',
    medical_documentation: 'Medical Documentation',
    medical_equipment: 'Medical Equipment',
    medical_imaging: 'Medical Imaging',
    medical_records: 'Medical Records',
    medical_software: 'Medical Software',
    medication_dispensing: 'Medication Dispensing',
    medication_management: 'Medication Management',
    membership_management: 'Membership Management',
    mental_health: 'Mental Health',
    menu_development: 'Menu Development',
    menu_planning: 'Menu Planning',
    merchandising: 'Merchandising',
    metal_fabrication: 'Metal Fabrication',
    metalworking: 'Metalworking',
    microbiology: 'Microbiology',
    mig_welding: 'MIG Welding',
    milling: 'Milling',
    mixing: 'Mixing',
    mobile_development: 'Mobile Development',
    mobile_repair: 'Mobile Repair',
    mortuary_services: 'Mortuary Services',
    motor_control: 'Motor Control',
    motor_repair: 'Motor Repair',
    multimedia_production: 'Multimedia Production',
    museum_education: 'Museum Education',
    music_education: 'Music Education',
    music_performance: 'Music Performance',
    music_production: 'Music Production',
    music_theory: 'Music Theory',
    narrative_writing: 'Narrative Writing',
    network_administration: 'Network Administration',
    network_configuration: 'Network Configuration',
    network_design: 'Network Design',
    network_installation: 'Network Installation',
    network_maintenance: 'Network Maintenance',
    network_monitoring: 'Network Monitoring',
    network_security: 'Network Security',
    network_troubleshooting: 'Network Troubleshooting',
    neurological_assessment: 'Neurological Assessment',
    news_writing: 'News Writing',
    nonprofit_management: 'Nonprofit Management',
    notary_services: 'Notary Services',
    nursery_management: 'Nursery Management',
    nursing_assessment: 'Nursing Assessment',
    nutrition_counseling: 'Nutrition Counseling',
    objective_c: 'Objective-C',
    occupational_health: 'Occupational Health',
    occupational_therapy: 'Occupational Therapy',
    oil_analysis: 'Oil Analysis',
    onboarding: 'Onboarding',
    operating_systems: 'Operating Systems',
    operational_efficiency: 'Operational Efficiency',
    operations_management: 'Operations Management',
    optical_systems: 'Optical Systems',
    order_fulfillment: 'Order Fulfillment',
    order_processing: 'Order Processing',
    organic_chemistry: 'Organic Chemistry',
    organic_farming: 'Organic Farming',
    organizational_development: 'Organizational Development',
    orthodontics: 'Orthodontics',
    orthopedics: 'Orthopedics',
    packaging: 'Packaging',
    packaging_design: 'Packaging Design',
    pain_management: 'Pain Management',
    painting: 'Painting',
    palliative_care: 'Palliative Care',
    paramedic_care: 'Paramedic Care',
    parent_communication: 'Parent Communication',
    parking_management: 'Parking Management',
    parts_management: 'Parts Management',
    pastry_arts: 'Pastry Arts',
    patent_law: 'Patent Law',
    pathology: 'Pathology',
    patient_assessment: 'Patient Assessment',
    patient_communication: 'Patient Communication',
    patient_education: 'Patient Education',
    patient_monitoring: 'Patient Monitoring',
    patient_scheduling: 'Patient Scheduling',
    pattern_making: 'Pattern Making',
    payroll_administration: 'Payroll Administration',
    pcb_design: 'PCB Design',
    pediatric_care: 'Pediatric Care',
    performance_evaluation: 'Performance Evaluation',
    performance_management: 'Performance Management',
    performance_testing: 'Performance Testing',
    permit_processing: 'Permit Processing',
    personal_training: 'Personal Training',
    pest_control: 'Pest Control',
    pest_management: 'Pest Management',
    pharmaceutical_calculations: 'Pharmaceutical Calculations',
    pharmacology: 'Pharmacology',
    pharmacy_operations: 'Pharmacy Operations',
    phlebotomy: 'Phlebotomy',
    photography: 'Photography',
    physical_assessment: 'Physical Assessment',
    physical_therapy: 'Physical Therapy',
    physics: 'Physics',
    piping_systems: 'Piping Systems',
    plan_review: 'Plan Review',
    plant_operations: 'Plant Operations',
    plasma_cutting: 'Plasma Cutting',
    plastering: 'Plastering',
    plc_programming: 'PLC Programming',
    plsql: 'PL/SQL',
    plumbing: 'Plumbing',
    plumbing_codes: 'Plumbing Codes',
    plumbing_systems: 'Plumbing Systems',
    pneumatic_systems: 'Pneumatic Systems',
    point_of_sale: 'Point Of Sale',
    policy_analysis: 'Policy Analysis',
    policy_development: 'Policy Development',
    pollination_management: 'Pollination Management',
    pollution_control: 'Pollution Control',
    polymer_science: 'Polymer Science',
    portfolio_management: 'Portfolio Management',
    pos_systems: 'POS Systems',
    post_production: 'Post Production',
    power_distribution: 'Power Distribution',
    power_systems: 'Power Systems',
    power_tools: 'Power Tools',
    precision_machining: 'Precision Machining',
    precision_measurement: 'Precision Measurement',
    predictive_maintenance: 'Predictive Maintenance',
    preventive_maintenance: 'Preventive Maintenance',
    print_production: 'Print Production',
    process_control: 'Process Control',
    process_design: 'Process Design',
    process_documentation: 'Process Documentation',
    process_engineering: 'Process Engineering',
    process_improvement: 'Process Improvement',
    process_optimization: 'Process Optimization',
    process_validation: 'Process Validation',
    product_design: 'Product Design',
    product_development: 'Product Development',
    product_knowledge: 'Product Knowledge',
    product_testing: 'Product Testing',
    production_planning: 'Production Planning',
    production_scheduling: 'Production Scheduling',
    program_evaluation: 'Program Evaluation',
    program_management: 'Program Management',
    project_coordination: 'Project Coordination',
    project_documentation: 'Project Documentation',
    project_planning: 'Project Planning',
    project_scheduling: 'Project Scheduling',
    promotion_planning: 'Promotion Planning',
    proofreading: 'Proofreading',
    property_law: 'Property Law',
    property_maintenance: 'Property Maintenance',
    property_management: 'Property Management',
    proposal_writing: 'Proposal Writing',
    prosthetics: 'Prosthetics',
    prototyping: 'Prototyping',
    psychiatric_care: 'Psychiatric Care',
    psychological_assessment: 'Psychological Assessment',
    public_health: 'Public Health',
    public_relations: 'Public Relations',
    purchasing: 'Purchasing',
    quality_assurance: 'Quality Assurance',
    quality_documentation: 'Quality Documentation',
    quality_inspection: 'Quality Inspection',
    quality_standards: 'Quality Standards',
    quality_systems: 'Quality Systems',
    quality_testing: 'Quality Testing',
    quantity_surveying: 'Quantity Surveying',
    radiography: 'Radiography',
    radiology: 'Radiology',
    real_estate_law: 'Real Estate Law',
    receiving: 'Receiving',
    recipe_development: 'Recipe Development',
    record_keeping: 'Record Keeping',
    recruitment: 'Recruitment',
    recycling_programs: 'Recycling Programs',
    refrigeration: 'Refrigeration',
    refrigeration_systems: 'Refrigeration Systems',
    regulatory_affairs: 'Regulatory Affairs',
    regulatory_compliance: 'Regulatory Compliance',
    rehabilitation: 'Rehabilitation',
    reliability_engineering: 'Reliability Engineering',
    remote_support: 'Remote Support',
    renewable_energy: 'Renewable Energy',
    repair_procedures: 'Repair Procedures',
    repair_techniques: 'Repair Techniques',
    report_writing: 'Report Writing',
    reservation_systems: 'Reservation Systems',
    residential_care: 'Residential Care',
    resource_allocation: 'Resource Allocation',
    resource_management: 'Resource Management',
    resource_planning: 'Resource Planning',
    respiratory_care: 'Respiratory Care',
    respiratory_therapy: 'Respiratory Therapy',
    restaurant_management: 'Restaurant Management',
    restoration: 'Restoration',
    retail_management: 'Retail Management',
    retail_operations: 'Retail Operations',
    revenue_management: 'Revenue Management',
    revit: 'Revit',
    rfid_systems: 'RFID Systems',
    risk_analysis: 'Risk Analysis',
    risk_assessment: 'Risk Assessment',
    risk_management: 'Risk Management',
    robotics: 'Robotics',
    roofing: 'Roofing',
    room_service: 'Room Service',
    root_cause_analysis: 'Root Cause Analysis',
    safety_audits: 'Safety Audits',
    safety_equipment: 'Safety Equipment',
    safety_inspections: 'Safety Inspections',
    safety_procedures: 'Safety Procedures',
    safety_protocols: 'Safety Protocols',
    safety_regulations: 'Safety Regulations',
    safety_systems: 'Safety Systems',
    safety_training: 'Safety Training',
    salon_management: 'Salon Management',
    sample_preparation: 'Sample Preparation',
    sanitation: 'Sanitation',
    sanitation_procedures: 'Sanitation Procedures',
    sawing: 'Sawing',
    scaffolding: 'Scaffolding',
    scada: 'SCADA',
    scanning_equipment: 'Scanning Equipment',
    scheduling: 'Scheduling',
    schematic_design: 'Schematic Design',
    schematic_reading: 'Schematic Reading',
    scope_management: 'Scope Management',
    scripting: 'Scripting',
    sculptural_techniques: 'Sculptural Techniques',
    security_assessment: 'Security Assessment',
    security_monitoring: 'Security Monitoring',
    security_operations: 'Security Operations',
    security_protocols: 'Security Protocols',
    security_systems: 'Security Systems',
    seed_selection: 'Seed Selection',
    sensor_technology: 'Sensor Technology',
    server_administration: 'Server Administration',
    server_maintenance: 'Server Maintenance',
    service_coordination: 'Service Coordination',
    service_delivery: 'Service Delivery',
    service_documentation: 'Service Documentation',
    service_management: 'Service Management',
    service_writing: 'Service Writing',
    sewing: 'Sewing',
    sheet_metal: 'Sheet Metal',
    sheet_metal_fabrication: 'Sheet Metal Fabrication',
    shelving: 'Shelving',
    shipping: 'Shipping',
    signal_processing: 'Signal Processing',
    site_management: 'Site Management',
    site_preparation: 'Site Preparation',
    site_supervision: 'Site Supervision',
    sketchup: 'SketchUp',
    skincare: 'Skincare',
    social_media_management: 'Social Media Management',
    social_services: 'Social Services',
    social_work: 'Social Work',
    software_architecture: 'Software Architecture',
    software_deployment: 'Software Deployment',
    software_documentation: 'Software Documentation',
    software_integration: 'Software Integration',
    software_testing: 'Software Testing',
    soil_analysis: 'Soil Analysis',
    soil_management: 'Soil Management',
    solar_installation: 'Solar Installation',
    soldering: 'Soldering',
    solidworks: 'SolidWorks',
    sound_design: 'Sound Design',
    sound_engineering: 'Sound Engineering',
    spa_services: 'Spa Services',
    space_planning: 'Space Planning',
    special_education: 'Special Education',
    spectroscopy: 'Spectroscopy',
    speech_therapy: 'Speech Therapy',
    sports_coaching: 'Sports Coaching',
    sports_medicine: 'Sports Medicine',
    spray_painting: 'Spray Painting',
    stakeholder_engagement: 'Stakeholder Engagement',
    stakeholder_management: 'Stakeholder Management',
    statistical_analysis: 'Statistical Analysis',
    steam_systems: 'Steam Systems',
    steel_fabrication: 'Steel Fabrication',
    sterilization: 'Sterilization',
    stock_management: 'Stock Management',
    storage_management: 'Storage Management',
    storyboarding: 'Storyboarding',
    strategic_planning: 'Strategic Planning',
    stress_testing: 'Stress Testing',
    structural_analysis: 'Structural Analysis',
    structural_design: 'Structural Design',
    student_assessment: 'Student Assessment',
    student_counseling: 'Student Counseling',
    student_engagement: 'Student Engagement',
    student_support: 'Student Support',
    substance_abuse: 'Substance Abuse',
    succession_planning: 'Succession Planning',
    supplier_management: 'Supplier Management',
    supply_planning: 'Supply Planning',
    surface_preparation: 'Surface Preparation',
    surgical_assistance: 'Surgical Assistance',
    surgical_instruments: 'Surgical Instruments',
    surgical_procedures: 'Surgical Procedures',
    surveillance_systems: 'Surveillance Systems',
    survey_design: 'Survey Design',
    surveying: 'Surveying',
    suspension_systems: 'Suspension Systems',
    sustainability_practices: 'Sustainability Practices',
    system_administration: 'System Administration',
    system_configuration: 'System Configuration',
    system_design: 'System Design',
    system_documentation: 'System Documentation',
    system_integration: 'System Integration',
    system_maintenance: 'System Maintenance',
    system_monitoring: 'System Monitoring',
    system_optimization: 'System Optimization',
    system_testing: 'System Testing',
    systems_analysis: 'Systems Analysis',
    talent_acquisition: 'Talent Acquisition',
    talent_development: 'Talent Development',
    tax_law: 'Tax Law',
    tax_planning: 'Tax Planning',
    team_building: 'Team Building',
    team_coordination: 'Team Coordination',
    team_leadership: 'Team Leadership',
    technical_documentation: 'Technical Documentation',
    technical_drawing: 'Technical Drawing',
    technical_support: 'Technical Support',
    technical_training: 'Technical Training',
    technical_writing: 'Technical Writing',
    technology_integration: 'Technology Integration',
    telecommunications: 'Telecommunications',
    telemedicine: 'Telemedicine',
    tenant_relations: 'Tenant Relations',
    testing_procedures: 'Testing Procedures',
    textile_design: 'Textile Design',
    textile_production: 'Textile Production',
    therapeutic_interventions: 'Therapeutic Interventions',
    therapy_planning: 'Therapy Planning',
    thermal_systems: 'Thermal Systems',
    threading: 'Threading',
    tig_welding: 'TIG Welding',
    tile_installation: 'Tile Installation',
    tool_maintenance: 'Tool Maintenance',
    tooling: 'Tooling',
    tort_law: 'Tort Law',
    tour_guiding: 'Tour Guiding',
    tourism_management: 'Tourism Management',
    training_delivery: 'Training Delivery',
    training_development: 'Training Development',
    training_programs: 'Training Programs',
    transaction_processing: 'Transaction Processing',
    transmission_repair: 'Transmission Repair',
    transportation_management: 'Transportation Management',
    travel_coordination: 'Travel Coordination',
    travel_planning: 'Travel Planning',
    triage: 'Triage',
    troubleshooting: 'Troubleshooting',
    turf_management: 'Turf Management',
    turning: 'Turning',
    tutoring: 'Tutoring',
    typography: 'Typography',
    ui_design: 'UI Design',
    ultrasound: 'Ultrasound',
    upholstery: 'Upholstery',
    user_experience: 'User Experience',
    user_interface: 'User Interface',
    user_training: 'User Training',
    utility_systems: 'Utility Systems',
    ux_design: 'UX Design',
    vaccination: 'Vaccination',
    valve_maintenance: 'Valve Maintenance',
    vendor_management: 'Vendor Management',
    ventilation: 'Ventilation',
    ventilation_systems: 'Ventilation Systems',
    version_control: 'Version Control',
    veterinary_medicine: 'Veterinary Medicine',
    veterinary_nursing: 'Veterinary Nursing',
    veterinary_surgery: 'Veterinary Surgery',
    video_production: 'Video Production',
    vineyard_management: 'Vineyard Management',
    virtual_reality: 'Virtual Reality',
    vision_testing: 'Vision Testing',
    visual_arts: 'Visual Arts',
    visual_communication: 'Visual Communication',
    visual_design: 'Visual Design',
    visual_merchandising: 'Visual Merchandising',
    vocabulary_development: 'Vocabulary Development',
    volunteer_management: 'Volunteer Management',
    warehouse_operations: 'Warehouse Operations',
    waste_disposal: 'Waste Disposal',
    waste_management: 'Waste Management',
    wastewater_treatment: 'Wastewater Treatment',
    water_quality: 'Water Quality',
    water_systems: 'Water Systems',
    water_treatment: 'Water Treatment',
    web_design: 'Web Design',
    wedding_planning: 'Wedding Planning',
    welding: 'Welding',
    welding_codes: 'Welding Codes',
    wellness_programs: 'Wellness Programs',
    wildlife_management: 'Wildlife Management',
    wind_energy: 'Wind Energy',
    wine_production: 'Wine Production',
    wiring: 'Wiring',
    woodworking: 'Woodworking',
    workforce_development: 'Workforce Development',
    workforce_planning: 'Workforce Planning',
    wound_care: 'Wound Care',
    writing_skills: 'Writing Skills',
    xcode: 'Xcode',
    x_ray: 'X-Ray',
    youth_development: 'Youth Development',
    zoning_regulations: 'Zoning Regulations',

    // Agriculture - Missing skills
    breeding_programs: 'Breeding Programs',
    breeding_techniques: 'Breeding Techniques',
    chainsaw_operation: 'Chainsaw Operation',
    combine_harvester: 'Combine Harvester Operation',
    crop_cultivation: 'Crop Cultivation',
    crop_planning: 'Crop Planning',
    crop_science: 'Crop Science',
    farm_management: 'Farm Management',
    farm_software: 'Farm Management Software',
    forest_inventory: 'Forest Inventory',
    forest_management: 'Forest Management',
    forest_protection: 'Forest Protection',
    forestry_planning: 'Forestry Planning',
    gis_mapping: 'GIS Mapping',
    gps_guidance: 'GPS Guidance',
    harvesting_techniques: 'Harvesting Techniques',
    irrigation_design: 'Irrigation Design',
    milk_quality_testing: 'Milk Quality Testing',
    milking_equipment: 'Milking Equipment',
    pest_identification: 'Pest Identification',
    plant_cultivation: 'Plant Cultivation',
    precision_agriculture: 'Precision Agriculture',
    pruning: 'Pruning',
    soil_testing: 'Soil Testing',
    timber_estimation: 'Timber Estimation',
    timber_harvesting: 'Timber Harvesting',
    timber_measurement: 'Timber Measurement',
    tractor_operation: 'Tractor Operation',
    tree_identification: 'Tree Identification',

    // Automotive - Missing skills
    automotive_wiring: 'Automotive Wiring',
    battery_systems: 'Battery Systems',
    ecu_programming: 'ECU Programming',
    obd_diagnostics: 'OBD Diagnostics',
    obd_scanner: 'OBD Scanner',
    vehicle_diagnostics: 'Vehicle Diagnostics',

    // Marketing & Content - Missing skills
    binding_equipment: 'Binding Equipment',
    cinematography: 'Cinematography',
    cms: 'CMS',
    cms_platforms: 'CMS Platforms',
    color_grading: 'Color Grading',
    color_management: 'Color Management',
    color_mixing: 'Color Mixing',
    color_theory: 'Color Theory',
    composition: 'Composition',
    content_editing: 'Content Editing',
    content_strategy: 'Content Strategy',
    creative_design: 'Creative Design',
    creative_software: 'Creative Software',
    creative_writing: 'Creative Writing',
    digital_art: 'Digital Art',
    editorial_leadership: 'Editorial Leadership',
    editorial_management: 'Editorial Management',
    editorial_work: 'Editorial Work',
    fact_checking: 'Fact Checking',
    grammar: 'Grammar',
    journalism: 'Journalism',
    lighting: 'Lighting',
    lightroom: 'Lightroom',
    mixing_consoles: 'Mixing Consoles',
    multimedia_software: 'Multimedia Software',
    news_judgment: 'News Judgment',
    opinion_writing: 'Opinion Writing',
    printing_equipment: 'Printing Equipment',
    publishing_management: 'Publishing Management',
    publishing_workflow: 'Publishing Workflow',
    recording_equipment: 'Recording Equipment',
    research: 'Research',
    sound_engineer: 'Sound Engineer',
    style_guides: 'Style Guides',
    user_research: 'User Research',

    // Logistics & Transportation - Missing skills
    bus_driving: 'Bus Driving',
    cargo_truck_driving: 'Cargo Truck Driving',
    customs_documentation: 'Customs Documentation',
    customs_inspection: 'Customs Inspection',
    customs_procedures: 'Customs Procedures',
    customs_software: 'Customs Software',
    forklift_certification: 'Forklift Certification',
    forklift_operation: 'Forklift Operation',
    freight_forwarding: 'Freight Forwarding',
    import_export_regulations: 'Import/Export Regulations',
    international_shipping: 'International Shipping',
    load_handling: 'Load Handling',
    loading_unloading: 'Loading/Unloading',
    logistics_control: 'Logistics Control',
    logistics_management: 'Logistics Management',
    logistics_software: 'Logistics Software',
    logistics_strategy: 'Logistics Strategy',
    material_handling: 'Material Handling',
    order_picking: 'Order Picking',
    package_handling: 'Package Handling',
    shipping_documentation: 'Shipping Documentation',
    shipping_procedures: 'Shipping Procedures',
    supply_chain_software: 'Supply Chain Software',
    tariff_classification: 'Tariff Classification',
    traffic_planning: 'Traffic Planning',
    transportation_engineering: 'Transportation Engineering',
    transportation_planning: 'Transportation Planning',
    warehouse_management_systems: 'Warehouse Management Systems',
    delivery_driving: 'Delivery Driving',
    delivery_services: 'Delivery Services',
    dispatch_operations: 'Dispatch Operations',
    driving: 'Driving',
    fleet_software: 'Fleet Software',
    gps_navigation: 'GPS Navigation',
    inventory_auditing: 'Inventory Auditing',
    inventory_systems: 'Inventory Systems',
    inventory_tracking: 'Inventory Tracking',
    load_securing: 'Load Securing',
    public_transport_driving: 'Public Transport Driving',
    railway_operations: 'Railway Operations',
    railway_systems: 'Railway Systems',
    route_knowledge: 'Route Knowledge',
    route_optimization: 'Route Optimization',
    stock_verification: 'Stock Verification',
    train_operation: 'Train Operation',
    train_scheduling: 'Train Scheduling',
    truck_driving: 'Truck Driving',
    vehicle_inspection: 'Vehicle Inspection',
    vehicle_maintenance: 'Vehicle Maintenance',

    // Legal - Missing skills
    authentication: 'Authentication',
    case_law: 'Case Law',
    case_management_software: 'Case Management Software',
    contract_management: 'Contract Management',
    court_filing: 'Court Filing',
    enforcement_procedures: 'Enforcement Procedures',
    legal_databases: 'Legal Databases',
    legal_judgment: 'Legal Judgment',
    legal_knowledge: 'Legal Knowledge',
    legal_management: 'Legal Management',
    legal_procedures: 'Legal Procedures',
    legal_software: 'Legal Software',
    notarial_procedures: 'Notarial Procedures',
    regulatory_databases: 'Regulatory Databases',
    regulatory_submissions: 'Regulatory Submissions',
    trial_management: 'Trial Management',

    // HR & Payroll - Missing skills
    compensation_planning: 'Compensation Planning',
    hr_systems: 'HR Systems',
    linkedin_recruiting: 'LinkedIn Recruiting',
    payroll_processing: 'Payroll Processing',
    payroll_software: 'Payroll Software',

    // Hospitality & Culinary - Missing skills
    baking: 'Baking',
    beverage_preparation: 'Beverage Preparation',
    cake_decoration: 'Cake Decoration',
    check_in_out: 'Check-In/Check-Out',
    coffee_preparation: 'Coffee Preparation',
    confectionery: 'Confectionery',
    cooking_techniques: 'Cooking Techniques',
    culinary_techniques: 'Culinary Techniques',
    dough_preparation: 'Dough Preparation',
    espresso_machines: 'Espresso Machines',
    food_beverage_management: 'Food & Beverage Management',
    food_beverage_pairing: 'Food & Beverage Pairing',
    food_chemistry: 'Food Chemistry',
    haccp: 'HACCP',
    hotel_management_software: 'Hotel Management Software',
    kitchen_equipment: 'Kitchen Equipment',
    kitchen_management: 'Kitchen Management',
    knife_skills: 'Knife Skills',
    local_knowledge: 'Local Knowledge',
    meat_cutting: 'Meat Cutting',
    meat_preparation: 'Meat Preparation',
    menu_knowledge: 'Menu Knowledge',
    mixology: 'Mixology',
    oven_operation: 'Oven Operation',
    pastry_making: 'Pastry Making',
    pizza_making: 'Pizza Making',
    pms_software: 'PMS Software',
    recipe_following: 'Recipe Following',
    table_service: 'Table Service',
    wine_knowledge: 'Wine Knowledge',
    wine_pairing: 'Wine Pairing',

    // Healthcare & Medical - Missing skills
    basic_nursing: 'Basic Nursing',
    blood_analysis: 'Blood Analysis',
    casting: 'Casting',
    cell_culture: 'Cell Culture',
    clinical_trials: 'Clinical Trials',
    compounding: 'Compounding',
    ct_scan: 'CT Scan',
    delivery_assistance: 'Delivery Assistance',
    dental_prosthetics: 'Dental Prosthetics',
    dental_software: 'Dental Software',
    dental_surgery: 'Dental Surgery',
    dietary_guidelines: 'Dietary Guidelines',
    elisa: 'ELISA',
    emergency_medical_care: 'Emergency Medical Care',
    epidemiology: 'Epidemiology',
    eye_examination: 'Eye Examination',
    gcp_compliance: 'GCP Compliance',
    health_programs: 'Health Programs',
    hygiene_procedures: 'Hygiene Procedures',
    hygiene_standards: 'Hygiene Standards',
    laboratory_analysis: 'Laboratory Analysis',
    laboratory_diagnostics: 'Laboratory Diagnostics',
    laboratory_samples: 'Laboratory Samples',
    language_assessment: 'Language Assessment',
    lens_fitting: 'Lens Fitting',
    life_support: 'Life Support',
    massage_techniques: 'Massage Techniques',
    medical_advisor: 'Medical Advisor',
    medical_auditing: 'Medical Auditing',
    medical_diagnosis: 'Medical Diagnosis',
    medical_knowledge: 'Medical Knowledge',
    medical_procedures: 'Medical Procedures',
    medical_writing: 'Medical Writing',
    medication_administration: 'Medication Administration',
    medication_reminders: 'Medication Reminders',
    microscopy: 'Microscopy',
    mri: 'MRI',
    nursing_auditing: 'Nursing Auditing',
    nursing_management: 'Nursing Management',
    nutrition_planning: 'Nutrition Planning',
    obstetrics: 'Obstetrics',
    optical_equipment: 'Optical Equipment',
    optical_measurements: 'Optical Measurements',
    orthopedic_devices: 'Orthopedic Devices',
    pacs_systems: 'PACS Systems',
    pcr: 'PCR',
    pharmaceutical_analysis: 'Pharmaceutical Analysis',
    pharmaceutical_auditing: 'Pharmaceutical Auditing',
    pharmaceutical_handling: 'Pharmaceutical Handling',
    pharmaceutical_knowledge: 'Pharmaceutical Knowledge',
    pharmaceutical_products: 'Pharmaceutical Products',
    pharmacovigilance: 'Pharmacovigilance',
    pharmacy_software: 'Pharmacy Software',
    prenatal_care: 'Prenatal Care',
    prescription_determination: 'Prescription Determination',
    prescription_verification: 'Prescription Verification',
    radiation_safety: 'Radiation Safety',
    rehabilitation_techniques: 'Rehabilitation Techniques',
    splinting: 'Splinting',
    therapeutic_exercises: 'Therapeutic Exercises',
    therapeutic_massage: 'Therapeutic Massage',
    therapeutic_techniques: 'Therapeutic Techniques',
    treatment_planning: 'Treatment Planning',
    urinalysis: 'Urinalysis',
    vital_signs_monitoring: 'Vital Signs Monitoring',
    x_ray_operation: 'X-Ray Operation',

    // Finance & Banking - Missing skills
    banking_operations: 'Banking Operations',
    financial_advisory: 'Financial Advisory',
    financial_instruments: 'Financial Instruments',
    financial_markets: 'Financial Markets',
    financial_mathematics: 'Financial Mathematics',
    financial_products: 'Financial Products',
    investment_products: 'Investment Products',
    pricing_analysis: 'Pricing Analysis',
    banking_products: 'Banking Products',
    banking_software: 'Banking Software',
    claim_assessment: 'Claim Assessment',
    collection_procedures: 'Collection Procedures',
    credit_assessment: 'Credit Assessment',
    credit_scoring: 'Credit Scoring',
    insurance_operations: 'Insurance Operations',
    insurance_products: 'Insurance Products',
    insurance_software: 'Insurance Software',
    insurance_systems: 'Insurance Systems',
    invoicing: 'Invoicing',
    leasing_operations: 'Leasing Operations',
    leasing_products: 'Leasing Products',
    lending_systems: 'Lending Systems',
    mortgage_products: 'Mortgage Products',
    payment_processing: 'Payment Processing',
    policy_administration: 'Policy Administration',
    policy_pricing: 'Policy Pricing',
    receivables_management: 'Receivables Management',
    reconciliation: 'Reconciliation',
    risk_evaluation: 'Risk Evaluation',
    risk_modeling: 'Risk Modeling',
    risk_software: 'Risk Software',
    settlement_procedures: 'Settlement Procedures',
    swift_messaging: 'SWIFT Messaging',
    tax_compliance: 'Tax Compliance',
    tax_software: 'Tax Software',
    trading_platforms: 'Trading Platforms',
    transaction_verification: 'Transaction Verification',
    treasury_systems: 'Treasury Systems',
    underwriting_software: 'Underwriting Software',
    wealth_management: 'Wealth Management',

    // Environment & Water Management - Missing skills
    eia: 'EIA (Environmental Impact Assessment)',
    environmental_assessment: 'Environmental Assessment',
    environmental_protection: 'Environmental Protection',
    environmental_regulations: 'Environmental Regulations',
    environmental_sampling: 'Environmental Sampling',
    iso_14001: 'ISO 14001',
    pump_operation: 'Pump Operation',
    water_chemistry: 'Water Chemistry',
    water_engineering: 'Water Engineering',
    water_quality_testing: 'Water Quality Testing',

    // Electrical & Electronics - Missing skills
    automation: 'Automation',
    circuit_design: 'Circuit Design',
    circuit_simulation: 'Circuit Simulation',
    circuit_testing: 'Circuit Testing',
    electrical_safety: 'Electrical Safety',
    electrical_wiring: 'Electrical Wiring',
    electronics_troubleshooting: 'Electronics Troubleshooting',
    ladder_logic: 'Ladder Logic',
    scada_systems: 'SCADA Systems',
    testing_equipment: 'Testing Equipment',

    // Education & Training - Missing skills
    behavior_management: 'Behavior Management',
    behavioral_management: 'Behavioral Management',
    classroom_support: 'Classroom Support',
    course_design: 'Course Design',
    curriculum_planning: 'Curriculum Planning',
    driving_instruction: 'Driving Instruction',
    early_childhood_education: 'Early Childhood Education',
    individualized_education_plans: 'Individualized Education Plans',
    lms_platforms: 'LMS Platforms',
    practical_instruction: 'Practical Instruction',
    scorm: 'SCORM',
    student_assistance: 'Student Assistance',
    student_mentoring: 'Student Mentoring',
    teaching_methods: 'Teaching Methods',
    traffic_regulations: 'Traffic Regulations',
    training_techniques: 'Training Techniques',
    university_teaching: 'University Teaching',
    vehicle_operation: 'Vehicle Operation',
    vocational_training: 'Vocational Training',
    workshop_management: 'Workshop Management',

    // Networking & Telecommunications - Missing skills
    backup_procedures: 'Backup Procedures',
    bss_systems: 'BSS Systems',
    cctv_installation: 'CCTV Installation',
    cisco_networking: 'Cisco Networking',
    coverage_planning: 'Coverage Planning',
    cybersecurity: 'Cybersecurity',
    fiber_optics: 'Fiber Optics',
    fraud_detection: 'Fraud Detection',
    incident_response: 'Incident Response',
    lte_5g: 'LTE/5G',
    mobile_networks: 'Mobile Networks',
    network_modeling: 'Network Modeling',
    network_operations: 'Network Operations',
    network_planning: 'Network Planning',
    network_testing: 'Network Testing',
    oss_systems: 'OSS Systems',
    penetration_testing: 'Penetration Testing',
    radio_network_optimization: 'Radio Network Optimization',
    radio_network_planning: 'Radio Network Planning',
    rf_engineering: 'RF Engineering',
    rf_planning: 'RF Planning',
    routing_switching: 'Routing & Switching',
    signal_testing: 'Signal Testing',
    tcp_ip: 'TCP/IP',
    telecommunications_equipment: 'Telecommunications Equipment',
    telecommunications_installation: 'Telecommunications Installation',
    user_management: 'User Management',
    virtualization: 'Virtualization',
    windows_server: 'Windows Server',

    // Database - Missing skills
    backup_recovery: 'Backup & Recovery',
    data_modeling: 'Data Modeling',
    database_optimization: 'Database Optimization',
    query_optimization: 'Query Optimization',
    replication: 'Replication',
    sql: 'SQL',
    sql_optimization: 'SQL Optimization',

    // Science & Research - Missing skills
    cataloging: 'Cataloging',
    chromatography: 'Chromatography',
    culture_methods: 'Culture Methods',
    flow_cytometry: 'Flow Cytometry',
    gc_ms: 'GC-MS',
    geodesy: 'Geodesy',
    geospatial_analysis: 'Geospatial Analysis',
    hplc: 'HPLC',
    information_retrieval: 'Information Retrieval',
    mass_spectrometry: 'Mass Spectrometry',
    mathematical_modeling: 'Mathematical Modeling',
    measurement_standards: 'Measurement Standards',
    metrology: 'Metrology',
    molecular_biology: 'Molecular Biology',
    research_methods: 'Research Methods',
    scientific_writing: 'Scientific Writing',
    sterile_techniques: 'Sterile Techniques',
    western_blot: 'Western Blot',

    // Construction & Building - Missing skills
    building_management: 'Building Management',
    construction_economics: 'Construction Economics',
    construction_planning: 'Construction Planning',
    construction_processes: 'Construction Processes',
    construction_software: 'Construction Software',
    construction_supervision: 'Construction Supervision',
    construction_technology: 'Construction Technology',
    drywall_installation: 'Drywall Installation',
    electrical_design: 'Electrical Design',
    excavators: 'Excavators',
    fem_software: 'FEM Software',
    flooring_installation: 'Flooring Installation',
    glass_calibration: 'Glass Calibration',
    glass_cutting: 'Glass Cutting',
    heavy_machinery: 'Heavy Machinery',
    insulation_installation: 'Insulation Installation',
    joinery: 'Joinery',
    leak_detection: 'Leak Detection',
    load_calculations: 'Load Calculations',
    mep_design: 'MEP Design',
    mortar_mixing: 'Mortar Mixing',
    pipe_fitting: 'Pipe Fitting',
    pipe_installation: 'Pipe Installation',
    plumbing_design: 'Plumbing Design',
    quantity_takeoff: 'Quantity Takeoff',
    rigging: 'Rigging',
    roofing_installation: 'Roofing Installation',
    safety_management: 'Safety Management',
    scaffolding_erection: 'Scaffolding Erection',
    sheet_metal_work: 'Sheet Metal Work',
    structural_knowledge: 'Structural Knowledge',
    taping_finishing: 'Taping & Finishing',
    tile_setting: 'Tile Setting',
    window_installation: 'Window Installation',
    windshield_replacement: 'Windshield Replacement',
    wood_cutting: 'Wood Cutting',

    // Marketing & Communications - Additional missing skills
    basic_analytics: 'Basic Analytics',
    branding: 'Branding',
    campaign_development: 'Campaign Development',
    campaign_strategy: 'Campaign Strategy',
    communication_platforms: 'Communication Platforms',
    community_management: 'Community Management',
    content_optimization: 'Content Optimization',
    crisis_communication: 'Crisis Communication',
    event_management: 'Event Management',
    internal_communications: 'Internal Communications',
    keyword_research: 'Keyword Research',
    marketing_campaigns: 'Marketing Campaigns',
    marketing_knowledge: 'Marketing Knowledge',
    marketing_management: 'Marketing Management',
    marketing_strategy: 'Marketing Strategy',
    marketing_support: 'Marketing Support',
    media_buying: 'Media Buying',
    media_planning: 'Media Planning',
    media_software: 'Media Software',
    online_marketing: 'Online Marketing',
    ppc_campaigns: 'PPC Campaigns',
    press_releases: 'Press Releases',
    social_media: 'Social Media',
    social_media_advertising: 'Social Media Advertising',
    social_media_platforms: 'Social Media Platforms',
    technical_seo: 'Technical SEO',
    vendor_coordination: 'Vendor Coordination',

    // Public Administration & Postal Services - Missing skills
    citizen_services: 'Citizen Services',
    mail_delivery: 'Mail Delivery',
    policy_implementation: 'Policy Implementation',
    postal_regulations: 'Postal Regulations',
    procurement_law: 'Procurement Law',
    public_administration: 'Public Administration',
    public_procurement: 'Public Procurement',
    regulatory_procedures: 'Regulatory Procedures',
    senior_advisory: 'Senior Advisory',
    senior_policy_advice: 'Senior Policy Advice',
    sorting: 'Sorting',
    tender_procedures: 'Tender Procedures',

    // Diverse Professional Skills - Missing skills (Part 1)
    avionics: 'Avionics',
    basic_cooking: 'Basic Cooking',
    basic_equipment: 'Basic Equipment',
    basic_math: 'Basic Math',
    basic_mechanics: 'Basic Mechanics',
    basic_patient_care: 'Basic Patient Care',
    basic_repairs: 'Basic Repairs',
    basic_skills: 'Basic Skills',
    basic_technology: 'Basic Technology',
    basic_tools: 'Basic Tools',
    beauty_treatments: 'Beauty Treatments',
    beverage_presentation: 'Beverage Presentation',
    blacksmithing: 'Blacksmithing',
    blasting: 'Blasting',
    bodywork_alignment: 'Bodywork Alignment',
    boiler_operation: 'Boiler Operation',
    cabin_service: 'Cabin Service',
    cable_installation: 'Cable Installation',
    call_center_management: 'Call Center Management',
    call_center_operations: 'Call Center Operations',
    call_center_software: 'Call Center Software',
    call_routing: 'Call Routing',
    canvas_preparation: 'Canvas Preparation',
    casino_games: 'Casino Games',
    cat_tools: 'CAT Tools',
    chemical_safety: 'Chemical Safety',
    childcare: 'Childcare',
    choreography: 'Choreography',
    cleaning: 'Cleaning',
    cleaning_equipment: 'Cleaning Equipment',
    client_advisory: 'Client Advisory',
    client_assessment: 'Client Assessment',
    client_consultation: 'Client Consultation',
    client_relationship: 'Client Relationship',
    coaching_methods: 'Coaching Methods',
    communication_systems: 'Communication Systems',
    communications: 'Communications',
    complaint_handling: 'Complaint Handling',
    complaint_management: 'Complaint Management',
    cooperative_management: 'Cooperative Management',
    country_management: 'Country Management',
    craftsmanship: 'Craftsmanship',
    crew_management: 'Crew Management',

    // Business Management & Planning - Missing skills
    business_development: 'Business Development',
    business_planning: 'Business Planning',
    business_processes: 'Business Processes',
    capacity_planning: 'Capacity Planning',
    cmms_systems: 'CMMS Systems',
    coordination: 'Coordination',
    demand_planning: 'Demand Planning',
    erp_systems: 'ERP Systems',
    facility_systems: 'Facility Systems',
    kpi_tracking: 'KPI Tracking',
    maintenance_coordination: 'Maintenance Coordination',
    maintenance_management: 'Maintenance Management',
    performance_analysis: 'Performance Analysis',
    performance_metrics: 'Performance Metrics',
    performance_tracking: 'Performance Tracking',
    process_analysis: 'Process Analysis',
    process_management: 'Process Management',
    product_management: 'Product Management',
    purchasing_software: 'Purchasing Software',
    requirement_analysis: 'Requirement Analysis',
    requirement_gathering: 'Requirement Gathering',
    roadmap_planning: 'Roadmap Planning',
    sprint_planning: 'Sprint Planning',
    supply_management: 'Supply Management',
    system_analysis: 'System Analysis',
    vendor_negotiation: 'Vendor Negotiation',
    vendor_relations: 'Vendor Relations',

    // Technical & Development - Missing skills
    bug_tracking: 'Bug Tracking',
    cocoa_touch: 'Cocoa Touch',
    composer: 'Composer',
    data_processing: 'Data Processing',
    debugging: 'Debugging',
    expert_knowledge: 'Expert Knowledge',
    integration_patterns: 'Integration Patterns',
    junit: 'JUnit',
    markdown: 'Markdown',
    maven: 'Maven',
    microservices: 'Microservices',
    pytest: 'PyTest',
    selenium: 'Selenium',
    system_architecture: 'System Architecture',
    technical_consultation: 'Technical Consultation',
    test_automation: 'Test Automation',
    test_cases: 'Test Cases',
    testing: 'Testing',
    user_manuals: 'User Manuals',

    // Diverse Professional Skills - Missing skills (Part 3)
    consecutive_interpreting: 'Consecutive Interpreting',
    cooking: 'Cooking',
    cutting_equipment: 'Cutting Equipment',
    cutting_tools: 'Cutting Tools',
    design_principles: 'Design Principles',
    dmx_control: 'DMX Control',
    finishing: 'Finishing',
    forging: 'Forging',
    fuel_dispensing: 'Fuel Dispensing',
    fur_working: 'Fur Working',
    gemstone_setting: 'Gemstone Setting',
    geology: 'Geology',
    gps_surveying: 'GPS Surveying',
    guest_reception: 'Guest Reception',
    hydrology: 'Hydrology',
    ic_design: 'IC Design',
    inspection_techniques: 'Inspection Techniques',
    modeling: 'Modeling',
    monitoring_control: 'Monitoring & Control',
    monitoring_equipment: 'Monitoring Equipment',
    monitoring_visits: 'Monitoring Visits',
    pedicure: 'Pedicure',
    precision_tools: 'Precision Tools',
    pressure_testing: 'Pressure Testing',
    production_procedures: 'Production Procedures',
    production_supervision: 'Production Supervision',
    semiconductor_technology: 'Semiconductor Technology',
    service_monitoring: 'Service Monitoring',
    speed_efficiency: 'Speed & Efficiency',
    styling: 'Styling',
    time_studies: 'Time Studies',
    tire_mounting: 'Tire Mounting',
    tire_pressure_monitoring: 'Tire Pressure Monitoring',
    tools_equipment: 'Tools & Equipment',
    tpms_systems: 'TPMS Systems',
    upholstery_techniques: 'Upholstery Techniques',
    vhdl_verilog: 'VHDL/Verilog',
    wig_styling: 'Wig Styling',
    wood_engineering: 'Wood Engineering',
    wood_processing: 'Wood Processing',
    wood_product_design: 'Wood Product Design',
    wood_technology: 'Wood Technology',

    // Diverse Professional Skills - Missing skills (Part 2)
    consulting: 'Consulting',
    consulting_methods: 'Consulting Methods',
    correspondence: 'Correspondence',
    counseling_techniques: 'Counseling Techniques',
    cultural_management: 'Cultural Management',
    cultural_programs: 'Cultural Programs',
    current_affairs: 'Current Affairs',
    customer_advisory: 'Customer Advisory',
    customer_communication: 'Customer Communication',
    customer_consultation: 'Customer Consultation',
    customer_verification: 'Customer Verification',
    dance_techniques: 'Dance Techniques',
    data_recording: 'Data Recording',
    data_verification: 'Data Verification',
    dealing_techniques: 'Dealing Techniques',
    dent_removal: 'Dent Removal',
    destination_knowledge: 'Destination Knowledge',
    detailing: 'Detailing',
    diagnostic_tools: 'Diagnostic Tools',
    dishwashing: 'Dishwashing',
    documentation: 'Documentation',
    donor_management: 'Donor Management',
    ecological_surveying: 'Ecological Surveying',
    economic_analysis: 'Economic Analysis',
    email_management: 'Email Management',
    english_translation: 'English Translation',
    entertainment_programs: 'Entertainment Programs',
    equipment_handling: 'Equipment Handling',
    event_decoration: 'Event Decoration',
    exercise_programs: 'Exercise Programs',
    fabric_knowledge: 'Fabric Knowledge',
    fashion_knowledge: 'Fashion Knowledge',
    fashion_software: 'Fashion Software',
    fem_analysis: 'FEM Analysis',
    fitness_training: 'Fitness Training',
    floor_care: 'Floor Care',
    floral_design: 'Floral Design',
    flower_arranging: 'Flower Arranging',
    following_instructions: 'Following Instructions',
    frame_selection: 'Frame Selection',
    front_desk_operations: 'Front Desk Operations',
    front_desk_software: 'Front Desk Software',
    fur_treatment: 'Fur Treatment',
    furniture_making: 'Furniture Making',
    furniture_repair: 'Furniture Repair',
    gaming_regulations: 'Gaming Regulations',
    geological_knowledge: 'Geological Knowledge',
    geological_surveying: 'Geological Surveying',
    german_translation: 'German Translation',
    hair_coloring: 'Hair Coloring',
    haircutting: 'Haircutting',
    handyman_skills: 'Handyman Skills',
    hardware_support: 'Hardware Support',
    height_work: 'Height Work',
    household_management: 'Household Management',
    hydraulic_design: 'Hydraulic Design',
    hygiene_care: 'Hygiene Care',
    installation: 'Installation',
    instrument_proficiency: 'Instrument Proficiency',
    itinerary_planning: 'Itinerary Planning',
    kitchen_cleaning: 'Kitchen Cleaning',
    knowledge_base: 'Knowledge Base',
    labeling: 'Labeling',
    land_surveying: 'Land Surveying',
    language_proficiency: 'Language Proficiency',
    language_skills: 'Language Skills',
    laundry: 'Laundry',
    leather_working: 'Leather Working',
    licensing_compliance: 'Licensing Compliance',
    literacy_review: 'Literacy Review',
    maintenance: 'Maintenance',
    makeup_techniques: 'Makeup Techniques',
    manicure: 'Manicure',
    manual_labor: 'Manual Labor',
    maritime_regulations: 'Maritime Regulations',
    materials_knowledge: 'Materials Knowledge',
    mathematics: 'Mathematics',
    measurement: 'Measurement',
    mechanical_knowledge: 'Mechanical Knowledge',
    mechatronics: 'Mechatronics',
    meeting_minutes: 'Meeting Minutes',
    metadata_cataloging: 'Metadata Cataloging',
    mining_equipment: 'Mining Equipment',
    mining_operations: 'Mining Operations',
    mixed_media: 'Mixed Media',
    mobility_assistance: 'Mobility Assistance',
    nail_care: 'Nail Care',
    navigation_equipment: 'Navigation Equipment',
    note_taking: 'Note Taking',
    nutrition_basics: 'Nutrition Basics',
    optimization: 'Optimization',
    packaging_equipment: 'Packaging Equipment',
    packaging_procedures: 'Packaging Procedures',
    paint_booth_operation: 'Paint Booth Operation',
    painting_techniques: 'Painting Techniques',
    panel_beating: 'Panel Beating',
    paper_handling: 'Paper Handling',
    patient_transport: 'Patient Transport',
    pattern_cutting: 'Pattern Cutting',
    performance: 'Performance',
    personal_hygiene: 'Personal Hygiene',
    persuasive_writing: 'Persuasive Writing',
    phone_systems: 'Phone Systems',
    physical_stamina: 'Physical Stamina',
    plant_knowledge: 'Plant Knowledge',
    polishing_machines: 'Polishing Machines',
    preservation_techniques: 'Preservation Techniques',
    pressure_washer: 'Pressure Washer',
    problem_resolution: 'Problem Resolution',
    process_simulation: 'Process Simulation',
    production_standards: 'Production Standards',
    productivity_standards: 'Productivity Standards',
    program_development: 'Program Development',
    property_care: 'Property Care',
    quality_sorting: 'Quality Sorting',
    registry_procedures: 'Registry Procedures',
    remote_desktop: 'Remote Desktop',
    reporting: 'Reporting',
    reservation_management: 'Reservation Management',
    reservation_procedures: 'Reservation Procedures',
    robot_programming: 'Robot Programming',
    rope_access: 'Rope Access',
    salon_equipment: 'Salon Equipment',
    sawmill_operation: 'Sawmill Operation',
    scanning_systems: 'Scanning Systems',
    scenic_design: 'Scenic Design',
    sealant_application: 'Sealant Application',
    seating_coordination: 'Seating Coordination',
    sewing_machines: 'Sewing Machines',
    ship_navigation: 'Ship Navigation',
    shoe_making: 'Shoe Making',
    signal_recognition: 'Signal Recognition',
    simulation_software: 'Simulation Software',
    simulation_tools: 'Simulation Tools',
    simultaneous_interpreting: 'Simultaneous Interpreting',
    sociological_research: 'Sociological Research',
    sop_compliance: 'SOP Compliance',
    special_effects: 'Special Effects',
    sports_training: 'Sports Training',
    staff_management: 'Staff Management',
    stage_presence: 'Stage Presence',
    standard_setting: 'Standard Setting',
    statistical_methods: 'Statistical Methods',
    statistical_software: 'Statistical Software',
    styling_software: 'Styling Software',
    switchboard_operation: 'Switchboard Operation',
    team_facilitation: 'Team Facilitation',
    team_supervision: 'Team Supervision',
    technical_analysis: 'Technical Analysis',
    technical_calculations: 'Technical Calculations',
    technical_expertise: 'Technical Expertise',
    technical_knowledge: 'Technical Knowledge',
    technical_management: 'Technical Management',
    technical_procedures: 'Technical Procedures',
    technical_processes: 'Technical Processes',
    technical_specifications: 'Technical Specifications',
    technical_troubleshooting: 'Technical Troubleshooting',
    temperature_control: 'Temperature Control',
    terminology_management: 'Terminology Management',
    theater_technology: 'Theater Technology',
    ticketing_systems: 'Ticketing Systems',
    total_station: 'Total Station',
    travel_booking_systems: 'Travel Booking Systems',
    trend_analysis: 'Trend Analysis',
    trend_awareness: 'Trend Awareness',
    verification_procedures: 'Verification Procedures',
    vocal_techniques: 'Vocal Techniques',
    wardrobe_management: 'Wardrobe Management',
    watch_repair: 'Watch Repair',
    wheel_balancing: 'Wheel Balancing',
    work_measurement: 'Work Measurement',
    workflow_planning: 'Workflow Planning',

    // Sales & Retail Management - Missing skills
    display_design: 'Display Design',
    e_commerce_platforms: 'E-Commerce Platforms',
    key_account_management: 'Key Account Management',
    phone_communication: 'Phone Communication',
    product_expertise: 'Product Expertise',
    product_placement: 'Product Placement',
    product_presentation: 'Product Presentation',
    product_promotion: 'Product Promotion',
    regional_management: 'Regional Management',
    retail_knowledge: 'Retail Knowledge',
    sales_analysis: 'Sales Analysis',
    sales_coaching: 'Sales Coaching',
    sales_management: 'Sales Management',
    sales_strategy: 'Sales Strategy',
    sales_support: 'Sales Support',
    sales_targets: 'Sales Targets',
    sales_techniques: 'Sales Techniques',
    section_management: 'Section Management',
    specialized_sales: 'Specialized Sales',
    store_management: 'Store Management',
    store_operations: 'Store Operations',
    telemarketing: 'Telemarketing',
    territory_management: 'Territory Management',
    upselling: 'Upselling',
    visual_displays: 'Visual Displays',

    // Safety, Security & Emergency Services - Missing skills
    emergency_planning: 'Emergency Planning',
    fire_codes: 'Fire Codes',
    fire_prevention: 'Fire Prevention',
    fire_safety_systems: 'Fire Safety Systems',
    firearms_handling: 'Firearms Handling',
    firefighting_equipment: 'Firefighting Equipment',
    hazmat_procedures: 'HAZMAT Procedures',
    investigation_techniques: 'Investigation Techniques',
    law_enforcement: 'Law Enforcement',
    military_operations: 'Military Operations',
    military_tactics: 'Military Tactics',
    navigation: 'Navigation',
    patrol_procedures: 'Patrol Procedures',
    physical_training: 'Physical Training',
    rescue_techniques: 'Rescue Techniques',
    safety_analysis: 'Safety Analysis',
    safety_inspection: 'Safety Inspection',
    safety_standards: 'Safety Standards',
    security_management: 'Security Management',
    security_procedures: 'Security Procedures',
    surveillance: 'Surveillance',
    swimming: 'Swimming',
    tactics: 'Tactics',
    water_safety: 'Water Safety',
    weapons_handling: 'Weapons Handling',

    // Manufacturing & Quality Management - Missing skills
    calipers_micrometers: 'Calipers & Micrometers',
    cmm_operation: 'CMM Operation',
    defect_analysis: 'Defect Analysis',
    foundry_equipment: 'Foundry Equipment',
    grinding_machines: 'Grinding Machines',
    iso_standards: 'ISO Standards',
    lean_manufacturing: 'Lean Manufacturing',
    machine_calibration: 'Machine Calibration',
    material_science: 'Material Science',
    material_testing: 'Material Testing',
    measurement_tools: 'Measurement Tools',
    metal_casting: 'Metal Casting',
    metallurgical_processes: 'Metallurgical Processes',
    metallurgy: 'Metallurgy',
    milling_machines: 'Milling Machines',
    mold_making: 'Mold Making',
    ndt_methods: 'NDT Methods',
    production_machinery: 'Production Machinery',
    production_management: 'Production Management',
    quality_monitoring: 'Quality Monitoring',
    quality_software: 'Quality Software',
    six_sigma: 'Six Sigma',
    statistical_process_control: 'Statistical Process Control',
    tool_changing: 'Tool Changing',
    tool_making: 'Tool Making',
    tool_setup: 'Tool Setup',
    turning_machines: 'Turning Machines',
    ultrasonic_testing: 'Ultrasonic Testing',
  },
};
